import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=686e472d&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e472d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686e472d')) {
      api.createRecord('686e472d', component.options)
    } else {
      api.reload('686e472d', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=686e472d&scoped=true&", function () {
      api.rerender('686e472d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/Card.vue"
export default component.exports